export default "__VITE_ASSET__AyWWqzjd__"